import React from 'react';

import './css/App.css';


import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'

import { MainPage } from './MainPage';
import { MenuElement } from './Menu';
import { RequestDemo } from './RequestDemo';
import { Performances } from './Performances';
import { Pricing } from './Pricing';
import { Technology } from './Technology';
import { Faq } from './Faq';
import { ContactPage } from './ContactPage';
// import { DebugMargins } from './DebugMargins';


// React Router keeps the scroll position across navigations, so a visitor who
// opens "Performances" from the bottom of the home page would land mid-page.
// Reset it on every navigation, bypassing the smooth scrolling that
// html { scroll-behavior } would otherwise animate across the page swap.
// A hash (the deep links /#trace, /#self-hosted, /#speed and /#mark into the sections) scrolls
// to that section instead, which also works from another page: the effect
// runs after the home page has rendered, so the target exists by then.
function ScrollToTop(): null {
	// Keyed on the location itself rather than its pathname, so clicking the
	// same link twice scrolls again instead of being ignored.
	const location = useLocation()

	React.useEffect( (): void => {
		if ( location.hash ) {
			const target: Element | null = document.querySelector( location.hash )
			if ( target ) {
				target.scrollIntoView( { behavior: 'smooth', block: 'start' } )
				return
			}
		}

		const html: HTMLElement = document.documentElement
		const previousBehavior: string = html.style.scrollBehavior
		html.style.scrollBehavior = 'auto'
		window.scrollTo( 0, 0 )
		html.style.scrollBehavior = previousBehavior
	}, [ location ] )

	return null
}


function App(): React.JSX.Element {


	return (
		<div className="App">
			<Router>
				<ScrollToTop />
				<MenuElement />
				<Routes>
					<Route path="/" element={<MainPage />} />
					<Route path="/technology" element={<Technology />} />
					<Route path="/pricing" element={<Pricing />} />
					<Route path="/faq" element={<Faq />} />
					<Route path="/contact" element={<ContactPage />} />
					<Route path="/performances" element={<Performances />} />
					<Route path="/request-demo" element={<RequestDemo />} />
					</Routes>
			</Router>
			{/* <DebugMargins /> */}
		</div>
	);
}

export default App;
